(function() {
    'use strict';
    angular.module('cabinFlightAdmin').directive('cabinFlightAdminSearch', cabinFlightAdminSearch).directive('focusOn', function($timeout) {
        return {
            restrict: 'A',
            link: function(vm, $element, $attr) {
                vm.$watch($attr.focusOn, function(_focusVal) {
                    $timeout(function() {
                        _focusVal ? $element[0].focus() : $element[0].blur();
                    });
                });
            }
        }
    });

    function cabinFlightAdminSearch(MessageService, $stateParams, applicationConstants, EventManagerService) {
        return {
            restrict: 'EA',
            scope: {
                onSearchCabinCrew: '&',
                showSearchArea: '=',
                crewTypes: '=',
                airports: '=',
                onChangeCrewType: '&',
                crewDetails: '=',
                departments : '='
            },
            templateUrl: 'cabin-flight-admin/directives/cabin-flight-admin-search-derective.tpl.html',
            replace: false,
            controllerAs: 'searchPanel',
            bindToController: true,
            controller: ['$scope',
                function($scope) {

                    var vm = this;
                    vm.model = {
                        fromDate: '',
                        toDate: '',
                        approved: null,
                        crewTypeCode: '',
                        crewName: null,
                        crewId: null,
                        origin: null,
                        destination: null,
                        department: null,
                        profileId: null,
                        masterList: {}
                    };

                    vm.model.masterList = {
                        fromDateAfterToDate: false,
                        fromDateFormatInvalid: false,
                        toDateFormatInvalid: false
                    };

                  vm.approvedList = [
                    {description: 'YES', value: 'Y'},
                    {description: 'NO', value: 'N'}
                  ];

                    var height = 70 + 40 + angular.element('.profile-tab-header').height();
                    angular.element(".search_panel_new").css("top", height);

                    function isDateFormatInvalid(date) {
                        if (!!date && !moment(date, "DD/MM/YYYY").isValid()) {
                            return true;
                        }
                        return false;
                    };

                    // check from date and to date
                    function istoDateBeforeFromDate() {
                        return moment(vm.model.toDate, "DD/MM/YYYY").isBefore(moment(vm.model.fromDate, "DD/MM/YYYY"));
                    };

                    function setDateValidationFlags() {
                        // if from date invalid
                        if (isDateFormatInvalid(vm.model.fromDate)) {
                            vm.model.masterList.fromDateFormatInvalid = true;
                            vm.model.masterList.fromDateAfterToDate = false;
                        } else {
                            vm.model.masterList.fromDateFormatInvalid = false;
                        }
                        // if to date invalid
                        if (isDateFormatInvalid(vm.model.toDate)) {
                            vm.model.masterList.toDateFormatInvalid = true;
                            vm.model.masterList.fromDateAfterToDate = false;
                        } else {
                            vm.model.masterList.toDateFormatInvalid = false;
                        }
                    };

                    function isValidSearchParams(params) {
                        setDateValidationFlags();
                        // if date invalid
                        if (vm.model.masterList.fromDateFormatInvalid || vm.model.masterList.toDateFormatInvalid) {
                            vm.model.masterList.fromDateAfterToDate = false;
                            return false;
                        } else if (istoDateBeforeFromDate()) {
                            vm.model.masterList.fromDateAfterToDate = true;
                            return false;
                        }
                        vm.model.masterList.fromDateAfterToDate = false;
                        return true;
                    }

                    EventManagerService.registerEventListener(EventManagerService.EVENT.FLIGHT_REPORT.CABIN_FLIGHT_RPT_EDIT, cabinFLightReportUpdate);

                    function cabinFLightReportUpdate(status) {
                        if(status){
                        	vm.onSearchCabinCrew({
                                'param': vm.model,'isNewSearch': false
                            });
                        }
                    }

                    vm.onSearchClick = function() {
                            if (vm.model.fromDate && vm.model.toDate && isValidSearchParams()) vm.onSearchCabinCrew({
                                'param': vm.model,'isNewSearch': true
                            });
                        }
                        // Search on page load
                    setDefaultSearchCriteria();

                    vm.onSearchClick();

                    vm.onSearchBarClick = function() {
                        vm.showSearchArea = !vm.showSearchArea;
                    }
                    vm.onFromDateChange = function() {
                        if (vm.model.fromDate) {
                            var moEnd = moment(vm.model.fromDate, applicationConstants.SETTINGS.DATE_FORMAT).endOf("month");
                            vm.model.toDate = moEnd.format(applicationConstants.SETTINGS.DATE_FORMAT);
                        }
                    }

                    vm.loadCrewID = function() {
                      vm.model.crewID = vm.model.crewDetails.crewId;
                    }


                    vm.loadCrewLists = function() {
                        vm.model.crewID = '';
                        vm.model.crewDetails = '';
                        if (!!vm.model.crewType) {
                            vm.onChangeCrewType({
                                crewType: vm.model.crewType.crewTypeCode
                            });
                        }
                    };

                    vm.crewIDEntered= function () {
                      vm.model.crewType = null;
                      vm.model.crewDetails = [];
                    }

                    function setDefaultSearchCriteria() {
                        vm.model.fromDate = moment().format(applicationConstants.SETTINGS.DATE_FORMAT);
                        vm.model.toDate = moment().format(applicationConstants.SETTINGS.DATE_FORMAT);
                    }
                }
            ],
            link: function(scope, element, attrs) {}
        };
    }
}());
